import React from "react";
import { FileText, Clock, CheckCircle, Star, AlertCircle, Users } from "lucide-react";
import { useSupportStats } from "../../../../hooks/useSupportTickets";

const SupportMetrics = () => {
  const { stats, loading, error } = useSupportStats();

  // Default metrics for when data is loading or unavailable
  const defaultMetrics = [
    {
      title: "Open Tickets",
      value: "0",
      icon: FileText,
      iconBg: "bg-orange-100",
      iconColor: "text-orange-600"
    },
    {
      title: "In Progress",
      value: "0",
      icon: Clock,
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600"
    },
    {
      title: "Resolved",
      value: "0",
      icon: CheckCircle,
      iconBg: "bg-green-100",
      iconColor: "text-green-600"
    },
    {
      title: "Avg Response Time",
      value: "0h",
      icon: Star,
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600"
    }
  ];

  // Transform API data to metrics format
  const getMetrics = () => {
    if (!stats || loading) {
      return defaultMetrics;
    }

    return [
      {
        title: "Open Tickets",
        value: stats.overall?.open?.toString() || "0",
        icon: FileText,
        iconBg: "bg-orange-100",
        iconColor: "text-orange-600"
      },
      {
        title: "In Progress",
        value: stats.overall?.inProgress?.toString() || "0",
        icon: Clock,
        iconBg: "bg-yellow-100",
        iconColor: "text-yellow-600"
      },
      {
        title: "Resolved",
        value: stats.overall?.resolved?.toString() || "0",
        icon: CheckCircle,
        iconBg: "bg-green-100",
        iconColor: "text-green-600"
      },
      {
        title: "Avg Response Time",
        value: stats.responseTime?.avgResponseTime ? `${stats.responseTime.avgResponseTime.toFixed(1)}h` : "0h",
        icon: Star,
        iconBg: "bg-blue-100",
        iconColor: "text-blue-600"
      }
    ];
  };

  const metrics = getMetrics();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
      {metrics.map((metric, index) => (
        <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm font-medium text-gray-600 mb-1">{metric.title}</p>
              <p className="text-xl sm:text-2xl font-bold text-gray-900">{metric.value}</p>
            </div>
            <div className={`p-2 sm:p-3 rounded-lg flex-shrink-0 ${metric.iconBg}`}>
              <metric.icon className={`w-4 h-4 sm:w-5 sm:h-5 ${metric.iconColor}`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SupportMetrics;
